import { SVGProps, Ref, forwardRef } from 'react';

export const EnvelopeFilledSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M1.24 5.36C.362 6.618 0 8.447 0 11v2c0 6 2 8 8 8h8c6 0 8-2 8-8v-2c0-2.553-.362-4.382-1.24-5.64L12 14.163zm1.316-1.25L12 11.837l9.444-7.727C20.194 3.326 18.424 3 16 3H8c-2.423 0-4.194.326-5.444 1.11"
                fill="currentColor"
            />
        </g>
    </svg>
));
EnvelopeFilledSize24Glyph.displayName = 'EnvelopeFilledSize24Glyph';
